import { Button } from "@/components/ui/button";
import { TIERS as T } from "@/constants/testIds";
import { Check } from "lucide-react";

export default function TierGrid({ tiers, onDonate, onPledge }) {
  const highlight = "launch_wall";
  return (
    <section id="tiers" className="py-20 sm:py-28 border-t border-white/10 bg-slate-950/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="mb-12">
          <div className="font-mono text-xs uppercase tracking-widest text-slate-500">// Back a tier</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-2">
            Pick your <span className="text-kinetic">spot</span> on the van
          </h2>
          <p className="mt-4 text-slate-400 max-w-2xl">
            Any amount works — these are just suggested tiers with specific perks. Donate by card or pledge without paying.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {tiers.map((t) => {
            const feat = t.id === highlight;
            return (
              <div
                key={t.id}
                data-testid={T.card(t.id)}
                className={`relative flex flex-col p-6 border transition-all hover:-translate-y-1 ${
                  feat
                    ? "bg-slate-950 border-kinetic shadow-[0_0_40px_rgba(255,69,0,0.15)]"
                    : "bg-slate-950/70 border-white/10 hover:border-white/25"
                }`}
              >
                {feat && (
                  <div className="absolute -top-3 left-6 px-2 py-0.5 bg-kinetic text-black font-mono text-[10px] uppercase tracking-widest font-bold">
                    Most Picked
                  </div>
                )}
                <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{t.id.replace(/_/g, " ")}</div>
                <div className="font-display font-black text-2xl mt-2 text-white uppercase">{t.name}</div>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className="font-display text-4xl font-black text-kinetic">${t.amount}</span>
                  <span className="font-mono text-xs text-slate-500">suggested</span>
                </div>
                <ul className="mt-5 space-y-2 flex-1">
                  {t.perks.map((p) => (
                    <li key={p} className="flex gap-2 text-sm text-slate-300">
                      <Check className="w-4 h-4 text-kinetic shrink-0 mt-0.5" /> {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 grid grid-cols-2 gap-2">
                  <Button
                    data-testid={T.donate(t.id)}
                    onClick={() => onDonate({ amount: t.amount, tier_id: t.id })}
                    className="rounded-none bg-kinetic hover:bg-[#FF5E1A] text-black font-bold uppercase text-xs tracking-wide"
                  >
                    Donate
                  </Button>
                  <Button
                    data-testid={T.pledge(t.id)}
                    onClick={() => onPledge({ amount: t.amount, tier_id: t.id })}
                    variant="outline"
                    className="rounded-none bg-transparent border-white/25 hover:bg-white/5 hover:text-white font-bold uppercase text-xs tracking-wide"
                  >
                    Pledge
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
